/**
 * Animates the growth of an integer number within a specified duration.
 *
 * @param {HTMLElement} element - The HTML element where the number will be displayed.
 * @param {number} start - The starting number.
 * @param {number} end - The ending number.
 * @param {number} duration - The duration of the animation in milliseconds.
 */
export function number_growth_int(element, start, end, duration) {
    let startTime = null;

    function step(timestamp) {
        if (!startTime) startTime = timestamp;
        const progress = Math.min((timestamp - startTime) / duration, 1);
        const value = Math.floor(progress * (end - start) + start);
        element.innerText = value;
        if (progress < 1) {
            window.requestAnimationFrame(step);
        }
    }

    window.requestAnimationFrame(step);
}

/**
 * Animates the growth of a floating-point number within a specified duration.
 *
 * @param {HTMLElement} element - The HTML element where the number will be displayed.
 * @param {number} start - The starting number.
 * @param {number} end - The ending number.
 * @param {number} duration - The duration of the animation in milliseconds.
 */
export function number_growth_float(element, start, end, duration, decimal_places = 2) {
    let startTimestamp = null;
    const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / duration, 1);
        const value = progress * (end - start) + start;
        element.textContent = value.toFixed(decimal_places); // Display two decimal places as default
        if (progress < 1) {
            window.requestAnimationFrame(step);
        }
    };
    window.requestAnimationFrame(step);
}